<template>
  <AppUnavailablePageLayout :show-user-data="false">
    <div class="sif-Content">
      <slot name="logo">
        <AppLogo class="sif-Content_Logo" height="40px" width="143px" />
      </slot>

      <AppTitle :level="1" class="sif-Content_Title" disable-margin>
        <slot>
          {{ $t('settings.init_failed') }}
        </slot>
      </AppTitle>
      <span class="sif-Content_SubTitle">{{ $t('settings.init_failed_refresh_page') }}</span>
    </div>
  </AppUnavailablePageLayout>
</template>

<script setup>
import AppUnavailablePageLayout from '@shared-modules/components/AppUnavailablePageLayout'

import AppLogo from '@/components/AppLogo'
import AppTitle from '@/components/ui/AppTitle/AppTitle'

defineOptions({
  name: 'AppSettingsInitFailed'
})
</script>

<style lang="scss" scoped>
.sif-Content_Logo {
  margin: 0 0 80px 0;
}

.sif-Content_Title {
  font-size: $fs-56;
  margin: 0 0 20px 0;
}

.sif-Content_SubTitle {
  color: $dark-3;
}

.sif-Content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: auto;
  height: 100%;
  padding: 40px;
}
</style>
